var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 178.6171 22.1103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dce9ba;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m20.4993,0v9.1916H3.7903V0H0v22.1103h3.7903v-9.5074h16.709v9.5074h3.7903V0h-3.7903Zm8.7176,0l10.8972,14.4664v7.6439h3.7903v-7.6439L54.77,0h-4.3588l-8.3703,11.2131L33.6074,0h-4.3905Zm45.4522,0h-14.9403v22.1103h3.7904v-7.6439h11.1499c5.37,0,8.939-2.59,8.939-7.2332,0-4.6115-3.569-7.2332-8.939-7.2332h0Zm-.316,11.2131h-10.8339V3.3166h10.8339c3.253,0,5.37,1.1055,5.37,3.9482,0,2.8112-2.117,3.9483-5.37,3.9483h0Zm20.72,5.717V0h-6.443v22.1103h21.32v-5.1802h-14.877Zm25.711,5.1802V0h-6.444v22.1103h6.444Zm29.627-17.0249V0h-23.153v22.1103h6.444v-7.8018h13.961v-5.0222h-13.961v-4.2009h16.709Zm10.96,12.0974v-3.9166h13.929v-4.7064h-13.929v-3.6324h16.899V0h-23.248v22.1103h23.595v-4.9275h-17.246Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5c20e151115066752b1164b500a76772.svg";
export { ForwardRef as ReactComponent };